import React, { useCallback, useContext } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../head-container';
import { getImageFromS3 } from '../../../../imageService';
import useTelegramLink from '../../../../hooks/useTelegramLink';
import { DataLayerEventContext } from '../../../../contexts/dataLayerEventContext';
import classNames from 'classnames';

const ResultComponent = ({ setScreenNumber, otpStatus, backToMenuButtonClick, isDarkMode = false }) => {
  const isSuccess = otpStatus === 'PENDING_OTP';
  const { telegramLink } = useTelegramLink();
  const { sendEvent } = useContext(DataLayerEventContext);

  const onTelegramClick = useCallback(() => {
    sendEvent('telegram');
    window.open(telegramLink, '_blank');
  }, [sendEvent, telegramLink]);

  return (
    <div
      className={classNames(styles.container, isDarkMode && styles.darkContainer)}
      style={{
        backgroundImage: isDarkMode ? '' : `url("${getImageFromS3(
          'images/lm-double-splash/violet-background.png'
        )}")`
      }}
    >
      <HeadContainer setScreenNumber={setScreenNumber} />
      <div className={styles.content}>
        <p className={styles.title}>
          {isSuccess ? 'Дякуємо за відгук!' : 'Дякуємо!'}
        </p>
        <p className={styles.subtitle}>
          {isSuccess
            ? 'Твій мобільний рахунок буде поповнено найближчим часом.'
            : 'Для отримання поповнення приходь наступного місяця!'}
        </p>
        <p className={classNames(styles.description, isDarkMode && styles.darkDescription)}>
          Долучайся у Телеграм, щоб бути на зв'язку зі своїм брендом.
        </p>
        <div className={styles.linkContainer}>
          <img
            src={getImageFromS3('images/lm-double-splash/telegram.png')}
            alt="telegram-icon"
            onClick={onTelegramClick}
          />
        </div>
        <button
          onClick={() => {
            backToMenuButtonClick ? backToMenuButtonClick() : setScreenNumber(1)
          }}
          className={classNames(styles.backButton, isDarkMode && styles.darkBackButton)}
        >
          Повернутися до меню
        </button>
      </div>
    </div>
  );
};

export default ResultComponent;
